import { Accordion } from "@circleco/compass/components/Accordion";
import { Box } from "@circleco/compass/components/Box";

import { t } from "@/i18n-js/instance";
import type { Space } from "@/react/types/Space";

import { Fields } from "./Fields";
import { Toggles } from "./Toggles";

interface OptionsProps {
  space?: Space;
}
export const Options = ({ space }: OptionsProps) => (
  <Box className="[&_[data-options-content]>div>div]:!pb-0 [&_[data-options-trigger]]:!py-0">
    <Accordion.Root>
      <Accordion.Item value="more-options" style={{ borderBottomWidth: 0 }}>
        <Accordion.Trigger data-options-trigger="">
          {t("image_space.post_modal.steps.create_post.more_options_label")}
        </Accordion.Trigger>
        <Accordion.Content data-options-content="">
          <div className="pt-6">
            <Toggles space={space} />
            <Fields space={space} />
          </div>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  </Box>
);
